import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=535edae6&scoped=true&"
import script from "./CommonHeader.vue?vue&type=script&lang=js&"
export * from "./CommonHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=535edae6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535edae6",
  null
  
)

export default component.exports